export default __webpack_public_path__ + "static/sectionBackground-6766893beff2abd5250695f7d3fa2696.png";